'use client';

import type { BlogGridProps } from '@routeroyal/theme-core';
import { RouteRoyalBlogCard } from './RouteRoyalBlogCard';

export function RouteRoyalBlogGrid({
  articles,
  variant = 'grid',
  columns = 3,
  emptyMessage = 'No articles found',
  locale = 'en',
  className = '',
}: BlogGridProps) {
  if (articles.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">{emptyMessage}</p>
      </div>
    );
  }

  const isList = variant === 'list';
  const gridClasses = isList
    ? 'space-y-6'
    : `grid gap-6 ${columns === 1 ? 'grid-cols-1' : columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'}`;

  const featuredArticle = !isList && articles.length > 0 ? articles[0] : null;
  const regularArticles = !isList && articles.length > 0 ? articles.slice(1) : articles;

  return (
    <div className={className}>
      {featuredArticle && (
        <div className="mb-8">
          <RouteRoyalBlogCard article={featuredArticle} variant="featured" locale={locale} />
        </div>
      )}
      {regularArticles.length > 0 && (
        <div className={gridClasses}>
          {regularArticles.map((article) => (
            <RouteRoyalBlogCard
              key={article.id}
              article={article}
              variant={isList ? 'compact' : 'default'}
              showExcerpt={!isList}
              locale={locale}
            />
          ))}
        </div>
      )}
    </div>
  );
}
